import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import DropdownList from '@stubhub/react-dropdown-list';

import {default as messages, titleMessages, sortValues, K_DATE, K_DISTANCE, K_PRICE, K_POPULAR} from './messages';

import './index.scss';

const ITEM_LIST = [K_DATE, K_DISTANCE, K_PRICE, K_POPULAR];

class EventSorter extends React.Component {
  static contextTypes = {
    globalRegistry: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    const {intl, selected = K_DATE} = this.props;
    let itemList = [];

    itemList = ITEM_LIST;

    this.sortItems = itemList.map((key) => {
      return {key, name: intl.formatMessage(messages[key]), value: sortValues[key]};
    });

    this.state = {
      item: this.getItemByKey(selected),
    };
  }

  getItemByKey = (key) => {
    const findResult = this.sortItems.filter((item) => item.key === key);

    return findResult.length > 0 ? findResult[0] : null;
  };

  onSelection = (item) => {
    const {onSelection} = this.props;
    onSelection(item);
    this.setState({item});
  };

  parseSelectionDisplay = ({key}) => {
    const {intl} = this.props;

    return intl.formatMessage(titleMessages[key || K_DATE]);
  };

  onClick = (e) => {
    const {onClick} = this.props;
    onClick(e);
  };

  render() {
    const {item} = this.state;
    const {className, draggable, useBackdrop} = this.props;
    const selected = item;

    return (
      <div className={className}>
        <DropdownList
          className="event-filter"
          selectionTitle={selected.name}
          selected={selected}
          items={this.sortItems}
          onSelection={this.onSelection}
          parseSelectionDisplay={this.parseSelectionDisplay}
          onClick={(e) => this.onClick(e)}
          useCheckMark
          inPillBar
          draggable={draggable}
          useBackdrop={useBackdrop}
        />
      </div>
    );
  }
}

EventSorter.defaultProps = {
  onClick: () => undefined,
  draggable: false,
  useBackdrop: false,
};

EventSorter.propTypes = {
  /** The intl object */

  intl: PropTypes.object.isRequired,
  selected: PropTypes.oneOf(ITEM_LIST),
  onSelection: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  draggable: PropTypes.bool,
  useBackdrop: PropTypes.bool,

  /**
   * The Class Name used to override the Styling for the component.
   */
  className: PropTypes.string,
};

export default injectIntl(EventSorter);
